import { Theme } from "@material-ui/core";
import { hexToRGB } from "src/util";

export const styles = (theme: Theme) => {
  const resetButtonBorderColor = `rgba(${hexToRGB(
    theme.palette.error.main
  )}, 0.75)`;
  return {
    resetButton: {
      "&:hover": {
        borderTopColor: resetButtonBorderColor,
        borderRightColor: resetButtonBorderColor,
        borderBottomColor: resetButtonBorderColor,
      },
      color: theme.palette.error.main,
    },
  };
};



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/components/seasons-editor/styles.ts